// Selects mock vs. real HTTP API based on VITE_USE_MOCK_API.
// Default = real backend (mock only when VITE_USE_MOCK_API=true).
// To use the in-app mock: set VITE_USE_MOCK_API=true.

import type { ProTreeApi } from './pro-tree.api';
import { proTreeHttpApi } from './pro-tree.api';
import { proTreeMockApi } from './pro-tree.mock.api';

const useMock = import.meta.env.VITE_USE_MOCK_API === 'true';

export const proTreeApi: ProTreeApi = useMock ? proTreeMockApi : proTreeHttpApi;
